import Component from './RecordsViewerLeaf.component';

export default Component;
